/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Calendar_Quota_Month_Other_OneInputs */

const fr_calendar_quota_month_other_one = /** @type {(inputs: Calendar_Quota_Month_Other_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 cours restant en ${i?.month}`)
};

/**

* @param {Calendar_Quota_Month_Other_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_month_other_one = /** @type {((inputs: Calendar_Quota_Month_Other_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Month_Other_OneInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_month_other_one(inputs)
});